module.exports = __webpack_public_path__ + "img/Stimmung.ef167355.jpg";